<template>
<Page leftMenu noFluid :noDrawer="!menu" class="docs">
    <template #submenu>
        <router-link v-for="(d, name) in docs" :key="name" :to="{name: 'docs', params: {chapter: name || undefined}}" :exact="!name">
            {{d.title}}
        </router-link>
    </template>

    <template v-if="menu" #drawer>
        <v-list-item v-if="menu.text" :to="{name: 'docs', params: {chapter}}" exact class="item">
            <v-list-item-content class="py-2">
                <v-list-item-title>Overview</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
        <template v-for="(g, group) in menu.items">
            <v-list-item style="font-weight: 600" :to="g.text ? {name: 'docs', params: {chapter, group}} : null" exact class="item">
                <v-list-item-content class="py-2">
                    <v-list-item-title>{{g.title}}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item v-for="(i, item) in g.items" link :to="{name: 'docs', params: {chapter, group, item}}" class="item">
                <v-list-item-content class="py-2">
                    <v-list-item-title class="ml-3" style="white-space: normal">
                        {{i.title}}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </template>
    </template>

    <template v-if="toc && toc.length > 1" #toc>
        <div class="my-4 toc-header">Contents</div>
        <div v-for="e in toc" class="toc-link" :class="{active: $route.hash === '#'+e.id}">
            <router-link :to="{hash: '#'+e.id}">
                {{e.title}}
            </router-link>
        </div>
    </template>

    <template v-if="doc">
        <h1>{{doc.title}}</h1>
        <component ref="text" :is="doc.text" />

        <v-row class="mt-16">
            <v-col cols="12" md="6">
                <v-list-item v-if="doc.prev" :to="{params: {group: doc.prev.to.group, item: doc.prev.to.item}}" exact-path large block outlined class="pagination prev">
                    <v-icon left>mdi-arrow-left</v-icon>
                    <div class="ml-5">
                        <div class="item">{{doc.prev.item}}</div>
                        <div class="group">{{doc.prev.group}}</div>
                    </div>
                </v-list-item>
            </v-col>
            <v-col cols="12" md="6">
                <v-list-item v-if="doc.next" :to="{params: {group: doc.next.to.group, item: doc.next.to.item}}" exact-path large block outlined class="pagination next">
                    <v-spacer />
                    <div class="mr-5">
                        <div class="item">{{doc.next.item}}</div>
                        <div class="group">{{doc.next.group}}</div>
                    </div>
                    <v-icon right>mdi-arrow-right</v-icon>
                </v-list-item>
            </v-col>
        </v-row>
    </template>
</Page>
</template>

<script>
import NodeAgentMetrics from "@/pages/docs/node-agent/Metrics";
import NodeAgentInstallation from "@/pages/docs/node-agent/Installation";
import NodeAgent from "@/pages/docs/node-agent/NodeAgent";
import PgAgent from "@/pages/docs/pg-agent/PgAgent";
import PgAgentInstallation from "@/pages/docs/pg-agent/Installation";
import PgAgentMetrics from "@/pages/docs/pg-agent/Metrics";
import AwsAgent from "@/pages/docs/aws-agent/AwsAgent";
import AwsAgentInstallation from "@/pages/docs/aws-agent/Installation";
import AwsAgentMetrics from "@/pages/docs/aws-agent/Metrics";
import Page from "@/pages/Page";
import MetricExporters from "@/pages/docs/MetricExporters";
import CEAlerting from "@/pages/docs/community/Alerting";
import CEAlertingSlack from "@/pages/docs/community/AlertingSlack";
import CEAlertingTeams from "@/pages/docs/community/AlertingTeams";
import CEAlertingPagerduty from "@/pages/docs/community/AlertingPagerduty";
import CEAlertingOpsgenie from "@/pages/docs/community/AlertingOpsgenie";
import CEAlertingWebhook from "@/pages/docs/community/AlertingWebhook";
import CEProfilingOverview from "@/pages/docs/community/ProfilingOverview";
import CELogsOverview from "@/pages/docs/community/LogsOverview.vue";
import CECostOverview from "@/pages/docs/community/CostOverview.vue";
import CETracingOverview from "@/pages/docs/community/TracingOverview";
import CEEbpfBasedTracing from "@/pages/docs/community/EbpfBasedTracing";
import OtelGo from "@/pages/docs/community/OtelGo";
import KubeStateMetrics from "@/pages/docs/kube-state-metrics/KubeStateMetrics";
import UsageStatistics from "@/pages/docs/community/UsageStatistics";
import CEInspections from "@/pages/docs/community/Inspections.vue";
import CEInspectionsSLO from "@/pages/docs/community/inspections/SLO.vue";
import CEInspectionsInstances from "@/pages/docs/community/inspections/Instances.vue";
import CEInspectionsCPU from "@/pages/docs/community/inspections/CPU.vue";
import CEInspectionsMemory from "@/pages/docs/community/inspections/Memory.vue";
import CEInspectionsStorage from "@/pages/docs/community/inspections/Storage.vue";
import CEInspectionsNetwork from "@/pages/docs/community/inspections/Network.vue";
import CEInspectionsLogs from "@/pages/docs/community/inspections/Logs.vue";
import CEInspectionsRedis from "@/pages/docs/community/inspections/Redis.vue";
import CEInspectionsPostgres from "@/pages/docs/community/inspections/Postgres.vue";
import CEInspectionsJVM from "@/pages/docs/community/inspections/JVM.vue";
import CEInspectionsDotNet from "@/pages/docs/community/inspections/DotNet.vue";
import CEInspectionsDeployments from "@/pages/docs/community/inspections/Deployments.vue";
import OtelJava from "@/pages/docs/community/OtelJava";
import OtelPython from "@/pages/docs/community/OtelPython";
import PerformanceImpact from "@/pages/docs/node-agent/PerformanceImpact.vue";
import Requirements from "@/pages/docs/coroot/Requirements.vue";
import QuickStartCE from "@/pages/docs/coroot/QuickStartCE.vue";
import Kubernetes from "@/pages/docs/coroot/Kubernetes.vue";
import Docker from "@/pages/docs/coroot/Docker.vue";
import DockerSwarm from "@/pages/docs/coroot/DockerSwarm.vue";
import Ubuntu from "@/pages/docs/coroot/Ubuntu.vue";
import RHEL from "@/pages/docs/coroot/RHEL.vue";
import Database from "@/pages/docs/coroot/Database.vue";
import ClickHouse from "@/pages/docs/coroot/ClickHouse.vue";
import Architecture from "@/pages/docs/coroot/Architecture.vue";
import Prometheus from "@/pages/docs/coroot/Prometheus.vue";
import Arguments from "@/pages/docs/coroot/Arguments.vue";
import Categories from "@/pages/docs/coroot/Categories.vue";
import CustomApps from "@/pages/docs/coroot/CustomApps.vue";
import Authentication from "@/pages/docs/coroot/Authentication.vue";
import RBAC from "@/pages/docs/coroot/RBAC.vue";
import QuickStartEE from "@/pages/docs/coroot/QuickStartEE.vue";
import SLOMonitoring from "@/pages/docs/coroot/SLOMonitoring.vue";
import Incidents from "@/pages/docs/coroot/Incidents.vue";


const docs = {
    'coroot': {
        title: 'Coroot',
        items: {
            'quick-start': {
                title: 'Quick-Start Guide',
                items: {
                    'community': {
                        title: 'Community Edition',
                        text: QuickStartCE,
                    },
                    'enterprise': {
                        title: 'Enterprise Edition',
                        text: QuickStartEE,
                    },
                },
            },
            'installation': {
                title: 'Installation',
                items: {
                    'requirements': {
                        title: 'Requirements',
                        text: Requirements,
                    },
                    'architecture': {
                        title: 'Architecture',
                        text: Architecture,
                    },
                    'kubernetes': {
                        title: 'Kubernetes',
                        text: Kubernetes,
                    },
                    'docker': {
                        title: 'Docker',
                        text: Docker,
                    },
                    'docker-swarm': {
                        title: 'Docker Swarm',
                        text: DockerSwarm,
                    },
                    'ubuntu': {
                        title: 'Ubuntu & Debian',
                        text: Ubuntu,
                    },
                    'rhel': {
                        title: 'RHEL & CentOS',
                        text: RHEL,
                    },
                    'performance-impact': {
                        title: 'Performance impact',
                        text: PerformanceImpact,
                    },
                },
            },
            'configuration': {
                title: 'Configuration',
                items: {
                    'authentication': {
                        title: 'Authentication',
                        text: Authentication,
                    },
                    'rbac': {
                        title: 'Role-Based Access Control',
                        text: RBAC,
                    },
                    'cli-arguments': {
                        title: 'CLI arguments',
                        text: Arguments,
                    },
                    'prometheus': {
                        title: 'Prometheus',
                        text: Prometheus,
                    },
                    'clickhouse': {
                        title: 'ClickHouse',
                        text: ClickHouse,
                    },
                    'database': {
                        title: 'Database',
                        text: Database,
                    },
                    'application-categories': {
                        title: 'Application categories',
                        text: Categories,
                    },
                    'custom-applications': {
                        title: 'Custom applications',
                        text: CustomApps,
                    },
                }
            },
            'alerting': {
                title: 'Alerting',
                items: {
                    'slo-monitoring': {
                        title: 'Service Level Objective (SLO) monitoring',
                        text: SLOMonitoring,
                    },
                    'incidents': {
                        title: 'Incidents',
                        text: Incidents,
                    },
                    'slack': {
                        title: 'Slack',
                        text: CEAlertingSlack,
                    },
                    'teams': {
                        title: 'Microsoft Teams',
                        text: CEAlertingTeams,
                    },
                    'pagerduty': {
                        title: 'Pagerduty',
                        text: CEAlertingPagerduty,
                    },
                    'opsgenie': {
                        title: 'Opsgenie',
                        text: CEAlertingOpsgenie,
                    },
                    'webhook': {
                        title: 'Webhook',
                        text: CEAlertingWebhook,
                    },
                }
            },
            'logs': {
                title: 'Logs Monitoring',
                items: {
                    'overview': {
                        title: 'Overview',
                        text: CELogsOverview,
                    },
                },
            },
            'tracing': {
                title: 'Distributed tracing',
                items: {
                    'overview': {
                        title: 'Overview',
                        text: CETracingOverview,
                    },
                    'ebpf-based-tracing': {
                        title: 'eBPF-based tracing',
                        text: CEEbpfBasedTracing,
                    },
                    'opentelemetry-go': {
                        title: 'OpenTelemetry for Go',
                        text: OtelGo,
                    },
                    'opentelemetry-java': {
                        title: 'OpenTelemetry for Java',
                        text: OtelJava,
                    },
                    'opentelemetry-python': {
                        title: 'OpenTelemetry for Python',
                        text: OtelPython,
                    },
                },
            },
            'inspections': {
                title: 'Inspections',
                items: {
                    'overview': {
                        title: 'Overview',
                        text: CEInspections,
                    },
                    'slo': {
                        title: "Service Level Objectives (SLOs)",
                        text: CEInspectionsSLO,
                    },
                    'instances': {
                        title: "Instances",
                        text: CEInspectionsInstances,
                    },
                    'cpu': {
                        title: "CPU",
                        text: CEInspectionsCPU,
                    },
                    'memory': {
                        title: "Memory",
                        text: CEInspectionsMemory,
                    },
                    'storage': {
                        title: "Storage",
                        text: CEInspectionsStorage,
                    },
                    'network': {
                        title: "Network",
                        text: CEInspectionsNetwork,
                    },
                    'logs': {
                        title: "Logs",
                        text: CEInspectionsLogs,
                    },
                    'jvm': {
                        title: "JVM",
                        text: CEInspectionsJVM,
                    },
                    'dotnet': {
                        title: ".NET",
                        text: CEInspectionsDotNet,
                    },
                    'redis': {
                        title: "Redis",
                        text: CEInspectionsRedis,
                    },
                    'postgres': {
                        title: "Postgres",
                        text: CEInspectionsPostgres,
                    },
                    'deployment-tracking': {
                        title: "Deployment tracking",
                        text: CEInspectionsDeployments,
                    }
                },
            },
            'profiling': {
                title: 'Continuous profiling',
                items: {
                    'overview': {
                        title: 'Overview',
                        text: CEProfilingOverview,
                    },
                },
            },
            'costs': {
                title: "Cloud cost monitoring",
                items: {
                    'overview': {
                        title: 'Overview',
                        text: CECostOverview,
                    }
                }
            },
            'misc': {
                title: "Misc",
                items: {
                    'anonymous-usage-statistics': {
                        title: 'Anonymous usage statistics',
                        text: UsageStatistics,
                    }
                }
            }
        }
    },
    'metric-exporters': {
        title: 'Metric exporters',
        text: MetricExporters,
        items: {
            'node-agent': {
                title: 'Node-agent',
                items: {
                    'overview': {
                        title: 'Overview',
                        text: NodeAgent,
                    },
                    'installation': {
                        title: 'Installation',
                        text: NodeAgentInstallation,
                    },
                    'metrics': {
                        title: 'Metrics',
                        text: NodeAgentMetrics,
                    }
                }
            },
            'pg-agent': {
                title: 'Pg-agent',
                items: {
                    'overview': {
                        title: 'Overview',
                        text: PgAgent,
                    },
                    'installation': {
                        title: 'Installation',
                        text: PgAgentInstallation,
                    },
                    'metrics': {
                        title: 'Metrics',
                        text: PgAgentMetrics,
                    },
                }
            },
            'aws-agent': {
                title: 'AWS-agent',
                items: {
                    'overview': {
                        title: 'Overview',
                        text: AwsAgent,
                    },
                    'installation': {
                        title: 'Installation',
                        text: AwsAgentInstallation,
                    },
                    'metrics': {
                        title: 'Metrics',
                        text: AwsAgentMetrics,
                    },
                }
            },
            'kube-state-metrics': {
                title: 'Kube-state-metrics',
                items: {
                    'installation': {
                        title: 'Installation',
                        text: KubeStateMetrics,
                    },
                }
            },
        },
    },
}

Object.keys(docs).forEach(c => {
    const chapter = docs[c];
    const groups = chapter.items;
    const list = [{group: chapter.title, item: 'Overview', to: {}}];
    Object.keys(groups).forEach(g => {
        Object.keys(groups[g].items).forEach(i => {
            list.push({group: groups[g].title, item: groups[g].items[i].title, to: {group: g, item: i}});
        })
    })
    chapter.next = list[1];
    let ii = 1;
    Object.keys(groups).forEach(g => {
        Object.keys(groups[g].items).forEach(i => {
            groups[g].items[i].prev = ii === 1 && !chapter.text ? null : list[ii-1];
            groups[g].items[i].next = ii < list.length-1 ? list[ii+1] : null;
            ii++;
        })
    })
})

export default {
    components: {Page},
    props: {
        chapter: String,
        group: String,
        item: String,
    },

    data() {
        return {
            doc: null,
            toc: [],
        };
    },

    mounted() {
        this.open();
    },

    watch: {
        key() {
            this.open();
        },
    },

    computed: {
        key() {
            return this.chapter + ':' + this.group + ':' + this.item;
        },
        docs() {
            return docs;
        },
        menu() {
            return (this.docs[this.chapter || ''] || {});
        },
        redirects() {
            switch (this.chapter) {
                case 'configuration':
                case 'inspections':
                    return {chapter: 'coroot', group: this.chapter, item: this.group};
                case 'coroot-community-edition':
                    return {chapter: 'coroot', group: this.group, item: this.item};
                case 'metrics':
                    return {chapter: 'metric-exporters', group: this.group, item: this.chapter};
            }
            return {
                chapter: 'coroot',
                group: 'quick-start',
                item: 'community',
            };
        }
    },

    methods: {
        open() {
            let doc = this.docs[this.chapter || ''];
            if (this.group && doc && doc.items) {
                doc = doc.items[this.group];
                if (doc && doc.items) {
                    if (this.item) {
                        doc = doc.items[this.item];
                    } else {
                        const firstItem = Object.keys(doc.items)[0];
                        if (firstItem) {
                            this.$router.replace({params: {item: firstItem}});
                            return;
                        }
                    }
                }
            }
            if (!doc || !doc.text) {
                this.$router.replace({name: 'docs', params: this.redirects});
                return;
            }
            this.doc = doc;
            this.$nextTick(() => {
                const doc = this.$refs.text.$el;
                const headers = doc.getElementsByTagName('h2');
                this.toc = Array.from(headers).filter(h => h.id).map(h => {
                    return {id: h.id, title: h.innerText}
                });
            })
        },
    },
};
</script>

<style scoped>
.docs {
    font-family: Poppins, sans-serif;
}
.item {
    min-height: 32px;
    margin-bottom: 0 !important;
}

.docs:deep(.v-card) {
    max-width: 95%; /* don't remove it, or the cards' borders could disappear */
    margin: 24px auto;
    padding: 20px;
}

.toc-header {
    color: rgba(0,0,0,0.87);
}
.toc-link {
    margin-left: 2px;
    border-left: 1px solid rgba(0,0,0,0.12);
    padding: 4px 4px 4px 12px;
}
.toc-link a {
    font-size: 14px;
    color: rgba(0,0,0,0.6);
}
.toc-link.active {
    border-left: 1px solid #1976d2;
}
.toc-link.active a {
    color: #1976d2;
}

.pagination {
    border: 1px solid rgba(0,0,0,0.12);
    border-radius: 4px;
    padding: 16px;
}
.pagination .item, .pagination .group {
    min-height: unset;
    /*white-space: nowrap;*/
}
.pagination .group {
    font-size: 14px;
    color: rgba(0,0,0,0.6);
}
</style>
